export const ADD_PERSISTENT_NOTIFICATION = 'ADD_PERSISTENT_NOTIFICATION';
export const REMOVE_PERSISTENT_NOTIFICATION = 'REMOVE_PERSISTENT_NOTIFICATION';
export const SET_COOKIE_BANNER_HIDDEN = 'SET_COOKIE_BANNER_HIDDEN';
export const SET_COUNTRY_GEO = 'SET_COUNTRY_GEO';
export const SET_ENV_VARS = 'SET_ENV_VARS';
export const SET_IP_ADDRESS = 'SET_IP_ADDRESS';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_DATA = 'SET_USER_DATA';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
